import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import Catalog from './pages/Catalog';
import Orders from './pages/Orders';
import Questions from './pages/Questions';
import Campaigns from './pages/Campaigns';
import MappingTool from './pages/MappingTool';
import Troubleshooting from './pages/Troubleshooting';
import Settings from './pages/Settings';
import Login from './pages/Login';
import InfluencerClients from './pages/InfluencerClients';
import { useUserCode } from './hooks/useUserCode';
import { SessionTimeout } from './components/SessionTimeout';

// Protege rotas que exigem autenticação
const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const token = localStorage.getItem('jwt_token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
};

// Layout com sidebar — usado em todas as páginas autenticadas
const AppLayout = ({ children }: { children: React.ReactNode }) => (
    <div className="flex h-screen bg-white overflow-hidden">
      <Sidebar />
      <main className="flex-1 overflow-y-auto">
        {children}
      </main>
    </div>
);

function App() {
  return (
      <BrowserRouter>
          <SessionTimeout />
          <Routes>
          <Route path="/login" element={<Login />} />

          {/* Rotas protegidas */}
          <Route
              path="/"
              element={
                <PrivateRoute>
                  <AppLayout>
                    <Dashboard />
                  </AppLayout>
                </PrivateRoute>
              }
          />
          <Route
              path="/catalog"
              element={
                <PrivateRoute>
                  <AppLayout>
                    <Catalog />
                  </AppLayout>
                </PrivateRoute>
              }
          />
          <Route
              path="/orders"
              element={
                <PrivateRoute>
                  <AppLayout>
                    <Orders />
                  </AppLayout>
                </PrivateRoute>
              }
          />
          <Route
              path="/campaigns"
              element={
                <PrivateRoute>
                  <AppLayout>
                    <Campaigns />
                  </AppLayout>
                </PrivateRoute>
              }
          />
          <Route
              path="/questions"
              element={
                <PrivateRoute>
                  <AppLayout>
                    <Questions />
                  </AppLayout>
                </PrivateRoute>
              }
          />
          <Route
              path="/channels"
              element={
                <PrivateRoute>
                  <AppLayout>
                    <MappingTool />
                  </AppLayout>
                </PrivateRoute>
              }
          />
          <Route
              path="/settings/troubleshooting"
              element={
                <PrivateRoute>
                  <AppLayout>
                    <Troubleshooting />
                  </AppLayout>
                </PrivateRoute>
              }
          />
          <Route
              path="/settings"
              element={
                <PrivateRoute>
                  <AppLayout>
                    <Settings />
                  </AppLayout>
                </PrivateRoute>
              }
          />
          <Route
              path="/customer-care"
              element={
                <PrivateRoute>
                  <AppLayout>
                    <div className="p-8"><h1 className="text-dark-100 text-3xl">Customer Care</h1></div>
                  </AppLayout>
                </PrivateRoute>
              }
          />
          <Route
              path="/business-requests"
              element={
                <PrivateRoute>
                  <AppLayout>
                    <div className="p-8"><h1 className="text-dark-100 text-3xl">Business Requests</h1></div>
                  </AppLayout>
                </PrivateRoute>
              }
          />
          <Route
              path="/sponsored-ads"
              element={
                <PrivateRoute>
                  <AppLayout>
                    <div className="p-8"><h1 className="text-dark-100 text-3xl">Sponsored Ads</h1></div>
                  </AppLayout>
                </PrivateRoute>
              }
          />
          <Route
              path="/apps"
              element={
                <PrivateRoute>
                  <AppLayout>
                    <div className="p-8"><h1 className="text-dark-100 text-3xl">Apps</h1></div>
                  </AppLayout>
                </PrivateRoute>
              }
          />

          <Route
              path="/influencer-clients"
              element={
                <PrivateRoute>
                  <AppLayout>
                    <InfluencerClients />
                  </AppLayout>
                </PrivateRoute>
              }
          />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
  );
}

export default App;
